// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HZZjp","tabsBox":"styles_tabsBox__3TmYt","createButton":"styles_createButton__1QGKf"};